var _path, _rect, _rect2, _rect3, _rect4, _rect5, _path2, _path3, _path4, _path5, _path6, _path7, _rect6, _rect7, _path8, _rect8, _rect9, _rect10, _path9, _rect11, _line, _circle, _circle2, _path10, _circle3, _line2, _circle4, _circle5, _path11, _circle6, _circle7, _path12, _line3, _line4, _line5, _line6, _line7, _rect12, _rect13, _rect14, _rect15, _rect16, _rect17, _rect18, _path13, _path14, _path15, _ellipse, _ellipse2, _g, _ellipse3, _path16, _path17, _path18, _path19;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgWithQuadrantDoctor(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 595,
    height: 450,
    viewBox: "0 0 595 450",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M233.421 263.751C234.783 258.744 239.329 255.27 244.518 255.27H506.954C514.533 255.27 520.04 262.474 518.051 269.788L474.156 431.154H187.885L233.421 263.751Z",
    fill: "#1D3F4F",
    stroke: "#DEE6EA"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 163.5,
    y: 431.115,
    width: 310.538,
    height: 18.3846,
    fill: "#052736",
    stroke: "#DEE6EA"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 73.5,
    y: 431.115,
    width: 212.923,
    height: 18.3846,
    fill: "#052736",
    stroke: "#DEE6EA"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 299,
    y: 15.7305,
    width: 201.151,
    height: 156.347,
    rx: 15,
    fill: "#001E2B",
    stroke: "#001E2B",
    strokeWidth: 2
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 298.75,
    y: 0.75,
    width: 201.651,
    height: 156.847,
    rx: 15.25,
    fill: "#374C2F",
    stroke: "#FFE212",
    strokeWidth: 1.5
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 384.061,
    y: 9.95703,
    width: 107.133,
    height: 138.435,
    rx: 15.25,
    fill: "#374C2F",
    stroke: "#FFE212",
    strokeWidth: 1.5
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M413.656 62.9042L413.325 63.2021V63.6475V72.3444V73.3444H414.325H472.304H473.304V72.3444V63.6475V63.2021L472.973 62.9042L443.983 36.8133L443.315 36.2113L442.646 36.8133L413.656 62.9042Z",
    fill: "#021F2B",
    stroke: "#021F2B",
    strokeWidth: 2
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M472.806 103.342L473.054 103.118L473.054 102.784L473.054 94.0872L473.054 93.3372L472.304 93.3372L414.325 93.3372L413.575 93.3372L413.575 94.0872L413.575 102.784L413.575 103.118L413.823 103.342L442.813 129.432L443.314 129.884L443.816 129.432L472.806 103.342Z",
    fill: "#021F2B",
    stroke: "#021F2B",
    strokeWidth: 1.5
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M403.844 54.5785L403.678 54.7275V54.9502V63.6471V64.1471H404.178H462.158H462.658V63.6471V54.9502V54.7275L462.492 54.5785L433.502 28.4877L433.168 28.1867L432.834 28.4877L403.844 54.5785Z",
    fill: "#001E2B",
    stroke: "#001E2B"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M403.509 54.2069L403.178 54.5048V54.9502V63.6471V64.6471H404.178H462.158H463.158V63.6471V54.9502V54.5048L462.827 54.2069L433.837 28.1161L433.168 27.514L432.499 28.1161L403.509 54.2069Z",
    fill: "#B1FF05",
    stroke: "#021F2B",
    strokeWidth: 2
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M462.659 94.6444L462.908 94.4209L462.908 94.0869L462.908 85.39L462.908 84.64L462.158 84.64L404.178 84.64L403.428 84.64L403.428 85.39L403.428 94.0869L403.428 94.4209L403.676 94.6444L432.666 120.735L433.168 121.187L433.67 120.735L462.659 94.6444Z",
    fill: "#00ED64",
    stroke: "#021F2B",
    strokeWidth: 1.5
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M362.921 79.1731C362.921 89.6058 354.464 98.0631 344.031 98.0631C333.598 98.0631 325.141 89.6058 325.141 79.1731C325.141 68.7405 333.598 60.2832 344.031 60.2832C354.464 60.2832 362.921 68.7405 362.921 79.1731Z",
    fill: "#27522C",
    stroke: "#B1FF05",
    strokeWidth: 1.5
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    x: 324.891,
    y: 29.3457,
    width: 38.2799,
    height: 11.275,
    rx: 5.63748,
    fill: "#27522C",
    stroke: "#B1FF05"
  })), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    x: 324.891,
    y: 117.725,
    width: 38.2799,
    height: 11.275,
    rx: 5.63748,
    fill: "#27522C",
    stroke: "#B1FF05"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M352.692 254.77V331.539C352.692 340.375 345.529 347.539 336.692 347.539H210.111L232.939 263.62C234.36 258.395 239.103 254.77 244.518 254.77H352.692Z",
    fill: "#052736"
  })), _rect8 || (_rect8 = /*#__PURE__*/React.createElement("rect", {
    x: 132.375,
    y: 108.375,
    width: 205.558,
    height: 226.327,
    rx: 15.625,
    fill: "#023443",
    stroke: "#00D2FF",
    strokeWidth: 0.75
  })), _rect9 || (_rect9 = /*#__PURE__*/React.createElement("rect", {
    x: 145.653,
    y: 77.7852,
    width: 34.6154,
    height: 69.9231,
    rx: 17.3077,
    transform: "rotate(-45 145.653 77.7852)",
    fill: "#052736"
  })), _rect10 || (_rect10 = /*#__PURE__*/React.createElement("rect", {
    x: 145.653,
    y: 72.3242,
    width: 34.6154,
    height: 69.9231,
    rx: 17.3077,
    transform: "rotate(-45 145.653 72.3242)",
    fill: "#023443"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M171.286 96.543L194.415 73.414L206.898 85.8972C213.285 92.2841 213.285 102.639 206.898 109.026C200.511 115.413 190.156 115.413 183.769 109.026L171.286 96.543Z",
    fill: "#04495E"
  })), _rect11 || (_rect11 = /*#__PURE__*/React.createElement("rect", {
    x: 146.36,
    y: 72.3242,
    width: 33.6154,
    height: 68.9231,
    rx: 16.8077,
    transform: "rotate(-45 146.36 72.3242)",
    stroke: "#00D2FF"
  })), _line || (_line = /*#__PURE__*/React.createElement("line", {
    x1: 170.266,
    y1: 96.9375,
    x2: 193.763,
    y2: 73.4398,
    stroke: "#00D2FF"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 221.385,
    cy: 53.3849,
    r: 19.3846,
    transform: "rotate(-90 221.385 53.3849)",
    fill: "#04495E"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 219.305,
    cy: 50.5392,
    r: 19.3846,
    transform: "rotate(-90 219.305 50.5392)",
    fill: "#023443"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M206.654 36.6934L232.882 62.9214L232.012 63.7921C224.769 71.0348 213.026 71.0348 205.784 63.7922C198.541 56.5495 198.541 44.8068 205.784 37.5641L206.654 36.6934Z",
    fill: "#04495E"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 219.305,
    cy: 50.5392,
    r: 18.8846,
    transform: "rotate(-90 219.305 50.5392)",
    stroke: "#00D2FF"
  })), _line2 || (_line2 = /*#__PURE__*/React.createElement("line", {
    x1: 205.813,
    y1: 37.0312,
    x2: 232.15,
    y2: 63.3682,
    stroke: "#00D2FF"
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    cx: 109.231,
    cy: 210.231,
    r: 33.2308,
    fill: "#052736"
  })), _circle5 || (_circle5 = /*#__PURE__*/React.createElement("circle", {
    cx: 106.231,
    cy: 206.307,
    r: 32.7308,
    fill: "#044F3F",
    stroke: "#80E88A"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M121.885 198.954L122.243 198.612L121.905 198.251L118.867 195.006L118.521 194.637L118.156 194.986L116.569 196.504L116.568 196.505L101.651 210.679L95.6454 205.065L94.0594 203.548L93.6981 203.203L93.3525 203.564L90.3145 206.74L89.9688 207.101L90.3302 207.447L91.9182 208.966L91.92 208.968L99.7899 216.423L99.7913 216.425L101.309 217.873L101.654 218.203L101.999 217.873L103.518 216.424L103.518 216.423L120.296 200.474L120.297 200.473L121.885 198.954Z",
    fill: "#80E88A",
    stroke: "#80E88A"
  })), _circle6 || (_circle6 = /*#__PURE__*/React.createElement("circle", {
    cx: 486.231,
    cy: 360.231,
    r: 33.2308,
    fill: "#052736"
  })), _circle7 || (_circle7 = /*#__PURE__*/React.createElement("circle", {
    cx: 490.231,
    cy: 357.231,
    r: 32.7308,
    fill: "#044F3F",
    stroke: "#80E88A"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M505.885 349.878L506.243 349.536L505.905 349.175L502.867 345.93L502.521 345.561L502.156 345.91L500.569 347.428L500.568 347.429L485.651 361.603L479.645 355.989L478.059 354.472L477.698 354.126L477.353 354.488L474.314 357.664L473.969 358.025L474.33 358.371L475.918 359.89L475.92 359.891L483.79 367.347L483.791 367.348L485.309 368.797L485.654 369.127L485.999 368.797L487.518 367.348L487.518 367.347L504.296 351.398L504.297 351.397L505.885 349.878Z",
    fill: "#80E88A",
    stroke: "#80E88A"
  })), _line3 || (_line3 = /*#__PURE__*/React.createElement("line", {
    x1: 355.461,
    y1: 205.309,
    x2: 493.231,
    y2: 205.309,
    stroke: "#DEE6EA",
    strokeWidth: 2,
    strokeDasharray: "5 5"
  })), _line4 || (_line4 = /*#__PURE__*/React.createElement("line", {
    x1: 87.5386,
    y1: 361.77,
    x2: 192.769,
    y2: 361.77,
    stroke: "#DEE6EA",
    strokeWidth: 2,
    strokeDasharray: "5 5"
  })), _line5 || (_line5 = /*#__PURE__*/React.createElement("line", {
    x1: 87.5386,
    y1: 379.77,
    x2: 167.154,
    y2: 379.77,
    stroke: "#DEE6EA",
    strokeWidth: 2,
    strokeDasharray: "5 5"
  })), _line6 || (_line6 = /*#__PURE__*/React.createElement("line", {
    x1: 355.461,
    y1: 223.309,
    x2: 414.308,
    y2: 223.309,
    stroke: "#001E2B",
    strokeWidth: 2,
    strokeDasharray: "5 5"
  })), _line7 || (_line7 = /*#__PURE__*/React.createElement("line", {
    x1: 432.308,
    y1: 223.309,
    x2: 509.846,
    y2: 223.309,
    stroke: "#DEE6EA",
    strokeWidth: 2,
    strokeDasharray: "5 5"
  })), _rect12 || (_rect12 = /*#__PURE__*/React.createElement("rect", {
    x: 157.375,
    y: 293.684,
    width: 150.173,
    height: 13.0962,
    rx: 6.54808,
    fill: "#04495E",
    stroke: "#00D2FF",
    strokeWidth: 0.75
  })), _rect13 || (_rect13 = /*#__PURE__*/React.createElement("rect", {
    x: 243.221,
    y: 202.299,
    width: 64.3269,
    height: 13.0962,
    rx: 6.54808,
    fill: "#04495E",
    stroke: "#00D2FF",
    strokeWidth: 0.75
  })), _rect14 || (_rect14 = /*#__PURE__*/React.createElement("rect", {
    x: 157.375,
    y: 263.375,
    width: 50.25,
    height: 13.25,
    rx: 6.625,
    fill: "#374C2F",
    stroke: "#FFE212",
    strokeWidth: 0.75
  })), _rect15 || (_rect15 = /*#__PURE__*/React.createElement("rect", {
    x: 218.298,
    y: 263.221,
    width: 89.25,
    height: 13.0962,
    rx: 6.54808,
    fill: "#04495E",
    stroke: "#00D2FF",
    strokeWidth: 0.75
  })), _rect16 || (_rect16 = /*#__PURE__*/React.createElement("rect", {
    x: 243.221,
    y: 171.838,
    width: 64.3269,
    height: 13.0962,
    rx: 6.54808,
    fill: "#044F3F",
    stroke: "#80E88A",
    strokeWidth: 0.75
  })), _rect17 || (_rect17 = /*#__PURE__*/React.createElement("rect", {
    x: 157.375,
    y: 232.76,
    width: 150.173,
    height: 13.0962,
    rx: 6.54808,
    fill: "#04495E",
    stroke: "#00D2FF",
    strokeWidth: 0.75
  })), _rect18 || (_rect18 = /*#__PURE__*/React.createElement("rect", {
    x: 243.221,
    y: 141.375,
    width: 64.3269,
    height: 13.0962,
    rx: 6.54808,
    fill: "#04495E",
    stroke: "#00D2FF",
    strokeWidth: 0.75
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M217.659 141.667C217.364 142.259 217.659 142.85 218.399 143.146L224.757 145.512C226.088 146.103 226.975 147.434 226.975 148.912V169.17C226.975 179.668 218.547 188.097 208.048 188.097C197.698 188.097 189.122 179.668 189.122 169.17V148.912C189.122 147.434 190.157 146.103 191.487 145.512L197.846 143.146C198.437 142.85 198.733 142.259 198.585 141.667C198.289 141.076 197.698 140.632 197.106 140.928L190.6 143.294C188.382 144.181 186.756 146.399 186.756 148.912V169.17C186.756 180.556 195.775 189.871 206.865 190.463V194.011C206.865 205.249 197.993 214.121 186.756 214.121C175.666 214.121 166.646 205.249 166.646 194.011V178.633C171.378 178.042 174.927 174.05 174.927 169.17C174.927 163.995 170.786 159.707 165.463 159.707C160.288 159.707 156 163.995 156 169.17C156 174.05 159.696 178.042 164.28 178.633V194.011C164.28 206.432 174.483 216.487 186.756 216.487C199.176 216.487 209.231 206.432 209.231 194.011V190.463C220.469 189.871 229.341 180.556 229.341 169.17V148.912C229.341 146.399 227.862 144.181 225.496 143.294L219.138 140.928C218.547 140.632 217.955 140.928 217.659 141.667ZM165.463 162.072C168.125 162.072 170.343 163.551 171.674 165.621C173.004 167.839 173.004 170.649 171.674 172.719C170.343 174.937 168.125 176.267 165.463 176.267C162.949 176.267 160.731 174.937 159.401 172.719C158.07 170.649 158.07 167.839 159.401 165.621C160.731 163.551 162.949 162.072 165.463 162.072Z",
    fill: "#001E2B"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M217.659 143.181C217.364 143.772 217.659 144.364 218.399 144.659L224.757 147.025C226.088 147.617 226.975 148.948 226.975 150.426V170.684C226.975 181.182 218.547 189.61 208.048 189.61C197.698 189.61 189.122 181.182 189.122 170.684V150.426C189.122 148.948 190.157 147.617 191.487 147.025L197.846 144.659C198.437 144.364 198.733 143.772 198.585 143.181C198.289 142.589 197.698 142.146 197.106 142.441L190.6 144.807C188.382 145.694 186.756 147.912 186.756 150.426V170.684C186.756 182.069 195.775 191.385 206.865 191.976V195.525C206.865 206.763 197.993 215.635 186.756 215.635C175.666 215.635 166.646 206.763 166.646 195.525V180.147C171.378 179.556 174.927 175.563 174.927 170.684C174.927 165.508 170.786 161.22 165.463 161.22C160.288 161.22 156 165.508 156 170.684C156 175.563 159.696 179.556 164.28 180.147V195.525C164.28 207.946 174.483 218 186.756 218C199.176 218 209.231 207.946 209.231 195.525V191.976C220.469 191.385 229.341 182.069 229.341 170.684V150.426C229.341 147.912 227.862 145.694 225.496 144.807L219.138 142.441C218.547 142.146 217.955 142.441 217.659 143.181ZM165.463 163.586C168.125 163.586 170.343 165.065 171.674 167.135C173.004 169.353 173.004 172.162 171.674 174.232C170.343 176.45 168.125 177.781 165.463 177.781C162.949 177.781 160.731 176.45 159.401 174.232C158.07 172.162 158.07 169.353 159.401 167.135C160.731 165.065 162.949 163.586 165.463 163.586Z",
    fill: "#001E2B"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M218.224 140.585L218.224 140.585L218.213 140.581C217.763 140.401 217.392 140.108 217.194 139.712C216.992 139.308 216.999 138.854 217.203 138.433C217.383 137.992 217.673 137.628 218.064 137.433C218.466 137.232 218.917 137.238 219.336 137.438L225.671 139.796L225.672 139.796C228.24 140.759 229.841 143.169 229.841 145.883V166.141C229.841 177.631 221.01 187.064 209.731 187.902V190.982C209.731 203.679 199.453 213.957 186.756 213.957C174.209 213.957 163.78 203.681 163.78 190.982V176.034C159.157 175.222 155.5 171.121 155.5 166.141C155.5 160.689 160.012 156.177 165.463 156.177C171.068 156.177 175.427 160.694 175.427 166.141C175.427 171.119 171.909 175.228 167.146 176.036V190.982C167.146 201.941 175.94 210.592 186.756 210.592C197.717 210.592 206.365 201.944 206.365 190.982V187.902C195.23 187.061 186.256 177.631 186.256 166.141V145.883C186.256 143.154 188.018 140.759 190.415 139.8L190.422 139.797L190.429 139.794L196.911 137.437C197.371 137.219 197.833 137.289 198.205 137.501C198.568 137.709 198.851 138.052 199.032 138.414L199.057 138.463L199.07 138.517C199.281 139.362 198.845 140.176 198.069 140.564L198.045 140.576L198.02 140.585L191.677 142.945C190.498 143.475 189.622 144.643 189.622 145.883V166.141C189.622 176.36 197.971 184.567 208.048 184.567C218.271 184.567 226.475 176.363 226.475 166.141V145.883C226.475 144.611 225.713 143.461 224.568 142.945L218.224 140.585ZM171.245 169.432L171.249 169.426L171.253 169.419C172.473 167.521 172.484 164.92 171.249 162.856C169.993 160.907 167.924 159.543 165.463 159.543C163.156 159.543 161.084 160.902 159.826 162.856C158.59 164.92 158.601 167.521 159.821 169.419L159.825 169.426L159.829 169.432C161.077 171.511 163.138 172.738 165.463 172.738C167.942 172.738 170.001 171.506 171.245 169.432Z",
    fill: "#00ED64",
    stroke: "#021F2B"
  })), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 165.451,
    cy: 166.163,
    rx: 6.4226,
    ry: 6.4226,
    fill: "white"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_1956_12468",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 159,
    y: 159,
    width: 13,
    height: 14
  }, _ellipse2 || (_ellipse2 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 165.451,
    cy: 166.163,
    rx: 6.4226,
    ry: 6.4226,
    fill: "#2970FF"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_1956_12468)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M169.732 164.535C169.732 169.887 161.883 168.103 161.169 170.957L162.596 174.525L175.085 172.028L172.944 156.328L161.526 156.685C160.812 157.636 160.853 161.996 161.883 160.967C163.31 159.539 169.732 159.183 169.732 164.535Z",
    fill: "#001E2B"
  }))), _ellipse3 || (_ellipse3 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 165.451,
    cy: 166.163,
    rx: 6.4226,
    ry: 6.4226,
    stroke: "#021F2B"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M191.455 138.202L199.875 135.466C201.278 135.01 202.786 135.778 203.242 137.182C203.698 138.585 202.93 140.093 201.526 140.549L193.107 143.285L191.455 138.202Z",
    fill: "#00ED64",
    stroke: "#021F2B"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M191.455 138.202L199.907 135.456C201.311 135 202.818 135.768 203.274 137.171C203.731 138.575 202.962 140.082 201.559 140.538L193.107 143.285L191.455 138.202Z",
    stroke: "#021F2B"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M224.541 138.202L216.121 135.466C214.718 135.01 213.21 135.778 212.754 137.182C212.298 138.585 213.066 140.093 214.47 140.549L222.889 143.285L224.541 138.202Z",
    fill: "#00ED64",
    stroke: "#021F2B"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M224.541 138.202L216.089 135.456C214.685 135 213.178 135.768 212.722 137.171C212.266 138.575 213.034 140.082 214.437 140.538L222.889 143.285L224.541 138.202Z",
    stroke: "#021F2B"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWithQuadrantDoctor);
export default __webpack_public_path__ + "static/media/with-quadrant-doctor.b8f3f985f2b1441c9aaac4cc04d4458a.svg";
export { ForwardRef as ReactComponent };